<aside class="{{inputRef?.nativeElement.childNodes.length ? 'has-input' : ''}}">
  <div class="c__wrapper">
    <form [formGroup]="formGroup">
      @if (!isDevice$) {
        <div class="c--filter-top {{_filters.length ? '' : 'has-no-filters'}} {{inputRef?.nativeElement.childNodes.length ? 'has-input' : ''}}"
          sdIsCollapsible
          [collapsiblePanel]="hide"
          [(isOpen)]="isOpenFilters"
          (click)="onOpenFilters()"
          [action]="triggerAction?.nativeElement"
        >
          @if (orderSelectConfig?.items?.length) {
            <fieldset>
              <sd-form select
                formControlName="orderBy"
                [brand]="brand"
                (valueChanged)="selectOrder()"
                [items]="orderSelectConfig?.items"
                [labelTitle]="'filters.orderBy' | translate"
                [selectedValue]="orderSelectConfig?.orderBy"
                [valueKey]="orderSelectConfig?.valueKey"
                [libelleKey]="orderSelectConfig?.libelleKey"
                [nameField]="orderSelectConfig?.nameField"
                [placeholder]="orderSelectConfig?.placeholder"
              />
            </fieldset>
          }
          @if (heading) {
            <div class="c__title {{!_filters?.length && !orderSelectConfig?.items?.length ? 'has-no-filter' : ''}}">
              @if (heading.title) {
                <sd-title
                  [titleLevel]="titleLevel"
                  [customClass]="'brand--h3 is-text-' + positionEnum.center"
                  [titleThemesConfig]="brandThemesEnum.brand"
                >
                  {{ heading.title }}
                </sd-title>
              }
              @if (heading.description) {
                <sd-title
                  [titleLevel]="titleLevel"
                  [customClass]="'is-medium is-text-' + positionEnum.center"
                  [isDescription]="true"
                >
                  {{ heading.description }}
                </sd-title>
              }
            </div>
          }
          <ng-container *ngTemplateOutlet="inputTemplate" />
          @if ((_filters.length || displayPrice) && showButton) {
            <button sd-button
              #action
              [attr.aria-expanded]="isOpenFilters"
              [attr.aria-controls]="idFilterCollapse"
              type="button"
              [brand]="brand"
              icon="icon-burger"
              [iconPos]="positionEnum.left"
            >
              <span>
                {{ "filters.title" | translate }} {{ filterTags?.length > 0 || displayPrice ? ("(" + (filterTags?.length + (displayPrice ? 1 : 0)) + ")") : "" }}
              </span>
            </button>
          }
        </div>
        <div #hide class="c__filters-list {{_filters.length ? '' : 'is-visually-hidden'}}" [attr.aria-expanded]="isOpenFilters" [id]="idFilterCollapse">
          @if (_filters.length) {
            @if (formRange) {
              <sd-form-range
                [inputMinValue]="priceMin"
                [inputMaxValue]="priceMax"
                [labelTitle]="'filters.range.title' | translate"
                (rangeValue)="priceRangeChange()"
                [rangeOptions]="formRange"
                [hideLimit]="true"
              />
            }
            <ul sd-list-inline class="is-m">
              @for (filter of _filters; track filter.name) {
                <li>
                  @if (filter.multiSelect === true) {
                    <sd-form
                      select-multiple
                      #selectMultiple
                      [hasAutocomplete]="filter.hasAutocomplete"
                      [brand]="brand"
                      [items]="filter.values"
                      (formChange)="selectFilter($event)"
                      [required]="false"
                      [labelHidden]="true"
                      [displayWidth]="filter.displayWidth"
                      [placeholder]="filter.name"
                      [labelTitle]="filter.name"
                      [nameField]="filter.name"
                    />
                  }
                  @if (filter.multiSelect !== true) {
                    <sd-form
                      select
                      [hasAutocomplete]="filter.hasAutocomplete"
                      [brand]="brand"
                      [items]="filter.values"
                      valueKey="value"
                      libelleKey="libelle"
                      [selectedValue]="getSelectFilterSelectedValue(filter)"
                      (valueChanged)="selectFilter($event)"
                      [required]="false"
                      [labelHidden]="true"
                      [displayWidth]="filter.displayWidth"
                      [placeholder]="filter.name"
                      [labelTitle]="filter.name"
                      [nameField]="filter.name"
                    />
                  }
                </li>
              }
            </ul>
          }
        </div>
        <div class="c__bottom-filter {{isOpenFilters ? 'is-opened' : ''}}">
          @if (superFilters?.length) {
            <ul sd-list-inline class="c__super-filters is-xs">
              @for (superFilter of superFilters; track superFilter.value) {
                <li>
                  <button sd-button
                    type="button"
                    [brand]="brand"
                    (click)="toggleSuperFilter(superFilter)"
                    [isSecondary]="!superFilter.value"
                    [attr.aria-pressed]="superFilter.value"
                  >
                    {{superFilter.label}}
                  </button>
                </li>
              }
            </ul>
          }
          @if (filterTags.length || displayPrice) {
            <ul class="c__tags is-xs" sd-list-inline>
              <li>
                <button type="button"
                  sd-button
                  [isSmall]="true"
                  class="is-clear"
                  [brand]="brand"
                  [attr.aria-label]="'filters.a11y.clearAllFiltersAriaLabel' | translate"
                  (click)="clearFilters()"
                  icon="icon-trash"
                >
                  <span>{{'filters.actions.clear' | translate}}</span>
                </button>
              </li>
              @if (displayPrice) {
                <li>
                  <sd-tag
                    [isButton]="true"
                    [tagData]="{icon: 'icon-cross', iconPos: positionEnum.right, ariaLabel: ('filters.range.title' | translate) + ': ' + priceMin + ' - ' + priceMax + ' ' + ('filters.a11y.clearFilterAriaLabel' | translate)}"
                    (tagClicked)="removeTag('price')"
                  >
                    {{'filters.range.title' | translate}}: {{priceMin}} - {{priceMax}}
                  </sd-tag>
                </li>
              }
              <!-- TODO-EL: faire un composant pour afficher la liste des tags -->
              @for (tag of filterTags; track tag.id) {
                <li>
                  <sd-tag
                    [isButton]="true"
                    class="is-filter"
                    [tagData]="{icon: 'icon-cross', iconPos: positionEnum.right, ariaLabel: tag.cat + ': ' + tag.filterValue?.libelle + ' ' + ('filters.a11y.clearFilterAriaLabel' | translate)}"
                    (tagClicked)="removeTag(tag)"
                  >
                    {{tag.cat}}: {{tag.filterValue?.libelle}}
                  </sd-tag>
                </li>
              }
            </ul>
          }
        </div>
      } @else {
        <ng-container *ngTemplateOutlet="inputTemplate" />
        <div class="c--filter-top {{_filters.length ? '' : 'has-no-filters'}} {{inputRef?.nativeElement.childNodes.length ? 'has-input' : ''}}">
          @if (_filters.length || displayPrice) {
            <button sd-button
              #mobileFilterButton
              [attr.aria-controls]="idFilterCollapse"
              [attr.aria-expanded]="isOpenFilters"
              type="button"
              (click)="toggleFilters()"
              [class]="heading?.title && heading?.description ? 'has-titles' : ''"
              [isSmall]="inputRef?.nativeElement.childNodes.length"
              [brand]="brand"
              icon="icon-burger"
              [iconPos]="positionEnum.left"
            >
              <span>{{ "filters.title" | translate }} {{ filterTags.length > 0 ? ("(" + filterTags.length + ")") : "" }}</span>
            </button>
          }
          @if (!_filters?.length && orderSelectConfig?.items?.length) {
            <fieldset>
              <sd-form select
                formControlName="orderBy"
                [brand]="brand"
                (valueChanged)="selectOrder()"
                [items]="orderSelectConfig?.items"
                [labelTitle]="'filters.orderBy' | translate"
                [selectedValue]="orderSelectConfig?.orderBy"
                [valueKey]="orderSelectConfig?.valueKey"
                [libelleKey]="orderSelectConfig?.libelleKey"
                [nameField]="orderSelectConfig?.nameField"
                [placeholder]="orderSelectConfig?.placeholder"
              />
            </fieldset>
          }
          @if (heading) {
            <div
              class="c__title {{!_filters?.length && !orderSelectConfig?.items?.length ? 'has-no-filter' : ''}}">
              @if (heading.title) {
                <sd-title
                  [titleLevel]="titleLevel"
                  [customClass]="'brand--h4 is-text-' + positionEnum.left"
                  [titleThemesConfig]="brandThemesEnum.brand"
                >
                  {{ heading.title }}
                </sd-title>
              }
              @if (heading.description) {
                <sd-title
                  [titleLevel]="titleLevel"
                  [customClass]="'is-medium is-text-' + positionEnum.left"
                  [isDescription]="true"
                >
                  {{ heading.description }}
                </sd-title>
              }
            </div>
          }
        </div>
        <div class="c__bottom-filter">
          @if (superFilters?.length) {
            <ul sd-list-inline class="c__super-filters is-xs">
              @for (superFilter of superFilters; track superFilter.value) {
                <li>
                  <button sd-button
                    type="button"
                    [brand]="brand"
                    (click)="toggleSuperFilter(superFilter)"
                    [isSecondary]="!superFilter.value"
                    [attr.aria-pressed]="superFilter.value"
                  >
                    {{superFilter.label}}
                  </button>
                </li>
              }
            </ul>
          }
          @if (!isMobile$ && (filterTags.length || displayPrice)) {
            <ul class="c__tags" sd-list-inline>
              <li>
                <button sd-button
                  type="button"
                  [isSmall]="true"
                  class="is-clear"
                  [attr.aria-label]="'filters.a11y.clearAllFiltersAriaLabel' | translate"
                  (click)="clearFilters()"
                  [brand]="brand"
                  icon="icon-trash"
                >
                  <span>{{'filters.actions.clear' | translate}}</span>
                </button>
              </li>
              @if (displayPrice) {
                <li>
                  <sd-tag
                    [isButton]="true"
                    [tagData]="{icon: 'icon-cross', iconPos: positionEnum.right, ariaLabel: ('filters.range.title' | translate) + ': ' + priceMin + ' - ' + priceMax + ' ' + ('filters.a11y.clearFilterAriaLabel' | translate)}"
                    (tagClicked)="removeTag('price')"
                  >
                    {{'filters.range.title' | translate}}: {{priceMin}} - {{priceMax}}
                  </sd-tag>
                </li>
              }
              @for (tag of filterTags; track tag.id) {
                <li>
                  <sd-tag
                    [isButton]="true"
                    class="is-filter"
                    [tagData]="{icon: 'icon-cross', iconPos: positionEnum.right, ariaLabel: tag.cat + ': ' + tag.filterValue?.libelle + ' ' + ('filters.a11y.clearFilterAriaLabel' | translate)}"
                    (tagClicked)="removeTag(tag)"
                  >
                    {{tag.cat}}: {{tag.filterValue?.libelle}}
                  </sd-tag>
                </li>
              }
            </ul>
          }
        </div>
      }

    </form>
  </div>

  <ng-template #inputTemplate>
    <div #inputRef class="c__form-input-container">
      <ng-content select="[sd-form-input]" />
    </div>
  </ng-template>

  @if (isDevice$) {
    <div class="c--modal-filters" [@slideInOutHorizontally]="isOpenFilters ? '1' : '0-with-height'">
      <form [formGroup]="formGroup">
        <header>
          <button sd-button-icon
            #closeModalButton
            (click)="toggleFilters()"
            [buttonIconTitle]="'actions.close' | translate"
            [class]="accordionOpen ? 'is-visually-hidden' : ''"
            [titleHidden]="true"
            [size]="iconSize.small"
            [brand]="brand"
            icon="icon-cross"
          ></button>
          <sd-title
            [titleLevel]="3"
            customClass="c__filter-title is-body-m is-bold"
            [class]="accordionOpen ? 'is-visually-hidden' : ''"
          >
            <span>{{'filters.title' | translate}}</span>
          </sd-title>
          @if (filterTags.length) {
            <button sd-button
              type="button"
              [isSmall]="true"
              class="c__clear-all"
              [attr.aria-label]="'filters.a11y.clearAllFiltersAriaLabel' | translate"
              (click)="clearFilters()"
              [brand]="brand"
              icon="icon-trash"
            >
              <span>{{'filters.actions.clear' | translate}}</span>
            </button>
          }
        </header>
        <sd-accordion-group
          #filtersAccordion
          [closeOthers]="true"
          (isOpened)="onClickOut($event)"
          [hideOthers]="true"
        >
          <sd-accordion
            [title]="'filters.orderBy' | translate"
            [titleLevel]="titleLevel"
            titleCustomClass="is-body-s is-regular"
            [isDrawer]="true"
            [closeOthers]="true"
            [brand]="brand"
            iconNameClosed="icon-arrow-right"
            iconNameOpened="icon-arrow-left"
            [buttonOpenHiddenTitle]="'filters.a11y.goBack' | translate"
            [iconPos]="positionEnum.right"
          >
            <sd-form select
              formControlName="orderBy"
              [brand]="brand"
              (valueChanged)="selectOrder()"
              [selectedValue]="orderSelectConfig?.orderBy"
              [items]="orderSelectConfig?.items"
              [labelTitle]="'filters.orderBy' | translate"
              [valueKey]="orderSelectConfig?.valueKey"
              [libelleKey]="orderSelectConfig?.libelleKey"
              [nameField]="orderSelectConfig?.nameField"
              [placeholder]="orderSelectConfig?.placeholder"
            />
          </sd-accordion>
          @if (!accordionOpen && formRange) {
            <sd-form-range
              [labelTitle]="'filters.range.title' | translate"
              [inputMinValue]="formGroup.get('minSelected').value"
              [inputMaxValue]="formGroup.get('maxSelected').value"
              [displayInput]="false"
              (rangeValue)="priceRangeChange()"
              [rangeOptions]="formRange"
              [hideLimit]="true"
            />
          }
          @for (filter of _filters; track filter.name) {
            <sd-accordion
              [title]="filter.name"
              [titleLevel]="titleLevel"
              titleCustomClass="is-body-s is-regular"
              [isDrawer]="true"
              [closeOthers]="true"
              [brand]="brand"
              iconNameClosed="icon-arrow-right"
              iconNameOpened="icon-arrow-left"
              [iconPos]="positionEnum.right"
              [buttonOpenHiddenTitle]="'filters.a11y.goBack' | translate"
            >
              @if (filter.multiSelect === true) {
                @if (filter.hasAutocomplete) {
                  <sd-form autocomplete
                    (formChange)="onChangeAutocomplete($event)"
                    classField="c__autocomplete-checkbox"
                    [optionsAreCheckboxes]="true"
                    [isSelect]="true"
                    [maxDisplayedResults]="-1"
                    [elements]="filter.values"
                    [properties]="['libelle']"
                    [minLength]="0"
                  />
                }
                @if (!filter.hasAutocomplete) {
                  <sd-form checkbox-group
                    #checkbox
                    [brand]="brand"
                    (checkedChange)="selectFilter($event)"
                    [nameField]="filter.name"
                    [required]="false"
                    [labelTitle]="filter.name"
                    [labelHidden]="true"
                    [items]="filter.values"
                  />
                }
              } @else {
                @if (filter.hasAutocomplete) {
                  <sd-form autocomplete
                    (formChange)="onChangeAutocomplete($event)"
                    classField="c__autocomplete-radio"
                    valueKey="value"
                    libelleKey="libelle"
                    libelle="libelle"
                    [optionsAreCheckboxes]="false"
                    [isSelect]="true"
                    [maxDisplayedResults]="-1"
                    [elements]="filter.values"
                    [properties]="['libelle']"
                    [minLength]="0"
                  />
                }
                @if (!filter.hasAutocomplete) {
                  <sd-form radio-group
                    class="c__btn-group c__content"
                    [required]="false"
                    [nameField]="filter.name"
                    [labelHidden]="true"
                    [labelTitle]="filter.name"
                    [items]="filter.values"
                    (valueChanged)="selectFilter($event)"
                  />
                }
              }
            </sd-accordion>
          }
        </sd-accordion-group>
        @if (!accordionOpen) {
          <footer class="c__tags">
            <ul sd-list-inline>
              <li>
                @if (displayPrice) {
                  <sd-tag
                    [isButton]="true"
                    [tagData]="{icon: 'icon-cross', iconPos: positionEnum.right, ariaLabel: ('filters.range.title' | translate) + ': ' + priceMin + ' - ' + priceMax + ' ' + ('filters.a11y.clearFilterAriaLabel' | translate)}"
                    (tagClicked)="removeTag('price')"
                  >
                    {{'filters.range.title' | translate}}: {{priceMin}} - {{priceMax}}
                  </sd-tag>
                }
              </li>
              @for (tag of filterTags; track tag.id) {
                <li>
                  <sd-tag
                    [isButton]="true"
                    class="is-filter"
                    [tagData]="{icon: 'icon-cross', iconPos: positionEnum.right, ariaLabel: tag.cat + ': ' + tag.filterValue?.libelle + ' ' + ('filters.a11y.clearFilterAriaLabel' | translate)}"
                    (tagClicked)="removeTag(tag)"
                  >
                    {{tag.cat}}: {{tag.filterValue?.libelle}}
                  </sd-tag>
                </li>
              }
            </ul>
          </footer>
        }
        @if (!accordionOpen) {
          <button sd-button
            type="button"
            [brand]="brand"
            (click)="!!accordionOpen ? !accordionOpen : toggleFilters()"
            class="c__see-results"
          >
            {{'filters.actions.viewResults' | translate}}
            @if (numberOfResults) {
              <span class="c__number-of-results">
                ({{numberOfResults}})
              </span>
            }
          </button>
        }
      </form>
      @if (!!accordionOpen) {
        <button sd-button
          type="button"
          [brand]="brand"
          (click)="!!accordionOpen ? !accordionOpen : toggleFilters()"
          class="c__save-filters"
        >
          {{'filters.actions.saveFilters' | translate}}
        </button>
      }
    </div>
  }
</aside>

@if (isOpenFilters && isDevice$) {
  <div class="c__filters-backdrop {{isOpenFilters ? 'is-visible' : ''}}" (click)="toggleFilters()">
  </div>
}
